import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 20H5C4.44772 20 4 19.5523 4 19V11.14C4 10.8807 4.10076 10.6315 4.281 10.445L9.781 4.74502C9.96945 4.54979 10.2292 4.43951 10.5005 4.43951C10.7719 4.43951 11.0315 4.54979 11.22 4.74502L13.356 6.96002L11.922 8.35402L10.5 6.88002L6 11.54V17.995H17V18.995C17.0013 19.2611 16.8966 19.5167 16.7089 19.7054C16.5212 19.894 16.2661 20 16 20ZM14.342 16L12.929 14.586L15.05 12.464L12.929 10.34L14.343 8.92602L16.464 11.047L18.585 8.92602L20 10.34L17.879 12.464L20 14.586L18.586 15.999L16.464 13.878L14.343 16H14.342Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "HomeX"
);
